<svelte:options customElement="preauth-main"/>

<script module>
	import { onMount } from "svelte";
	import GlobalLoader, { Loader } from "./ursCommon/GlobalLoader.svelte";
	import { loadAssets } from "./ursCommon/Common.svelte";
</script>

<script>

    let dateString = $state(null);

    function displayTime() {
      const date = new Date();
      dateString = date.toLocaleTimeString();
    }

    onMount(() => {

        setTimeout(() => {
            loadAssets("preauth-main");
            //setTimeout( function() { Loader.display("This is a demo of a Svelte component. Going away in 3 seconds."); }, 100 );
            //setTimeout( function() { Loader.hide(); }, 3000 );
        }, 10);
      
        setInterval(displayTime, 1000);

    });
           
</script>
<div class="display-2 text-primary">{dateString}</div>

<GlobalLoader />


<style>


</style>